module.exports = __webpack_public_path__ + "img/user.4a28dd1b.svg";